import React from "react";
import SearchableSelect from "modules/swiftboard/components/ui/SearchableSelect";
import Toggle from "modules/swiftboard/components/ui/Toggle";
import { getTemplateFields } from "../../features/template.fields";

const enumOptions = (fieldName) => {
  const field = getTemplateFields(false).find((f) => f.name === fieldName);
  return (field?.enums || []).map((v) => ({ value: v, label: v.replace(/_/g, " ") }));
};

const TEMPLATE_KEY_OPTIONS = enumOptions("template_key");
const MAILING_FOR_OPTIONS = enumOptions("mailing_for");
const EMAIL_TYPE_OPTIONS = enumOptions("email_type");

const inputClass = (hasError) =>
  `w-full px-3 py-2 text-sm rounded-lg border bg-surface_alt text-text_primary placeholder:text-text_muted focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition ${
    hasError ? "border-danger" : "border-border"
  }`;

const StepBasicInfo = ({ formData, setField, errors, isEditing, lockMailingFor = false }) => {
  const isMarketing = formData.mailing_for === "MARKETING";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {!isMarketing && (
        <div className="md:col-span-2">
          <label className="block text-xs font-medium text-text_secondary mb-1.5">
            Template Key {!isEditing && <span className="text-danger">*</span>}
          </label>
          <SearchableSelect
            options={TEMPLATE_KEY_OPTIONS}
            value={formData.template_key}
            onChange={(val) => setField("template_key", val)}
            placeholder="Select template key"
            isDisabled={isEditing}
            hasError={Boolean(errors.template_key)}
          />
          {errors.template_key && <p className="text-[11px] text-danger mt-1">{errors.template_key}</p>}
        </div>
      )}

      <div className="md:col-span-2">
        <label className="block text-xs font-medium text-text_secondary mb-1.5">
          Template Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          value={formData.template_name || ""}
          onChange={(e) => setField("template_name", e.target.value)}
          placeholder="e.g. Project Assigned Notification"
          className={inputClass(errors.template_name)}
        />
        {errors.template_name && <p className="text-[11px] text-danger mt-1">{errors.template_name}</p>}
      </div>

      <div className={isMarketing ? "md:col-span-2" : ""}>
        <label className="block text-xs font-medium text-text_secondary mb-1.5">Mailing For</label>
        <SearchableSelect
          options={MAILING_FOR_OPTIONS}
          value={formData.mailing_for}
          onChange={(val) => setField("mailing_for", val)}
          placeholder="Select mailing category"
          isDisabled={lockMailingFor}
        />
      </div>

      {!isMarketing && (
        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5">Email Type</label>
          <SearchableSelect
            options={EMAIL_TYPE_OPTIONS}
            value={formData.email_type}
            onChange={(val) => setField("email_type", val)}
            placeholder="Select email type"
          />
        </div>
      )}

      <div className="md:col-span-2 flex items-center justify-between px-3 py-2.5 rounded-lg border border-border bg-surface_alt">
        <span className="text-xs font-medium text-text_secondary">Active</span>
        <Toggle checked={Boolean(formData.is_activated)} onChange={(val) => setField("is_activated", val)} />
      </div>
    </div>
  );
};

export default StepBasicInfo;
